import { withTranslation } from 'react-i18next';
import CheckData from '../../../components/CatchError';
import CommerceTabs from '../../../components/CommerceTabs';
import Component from '../../../components/Component';
import DataTable from '../../../components/Datatable';
import { changeIntent } from '../../../helpers/commerce';
import { getSortKeys, setAdditionalStyles } from '../../../helpers/table';
import ExtraBox from './extrabtns';
import { COLUMNS } from './keys';
import query from './query';
import { v4 as uuid } from 'uuid';

class CommerceViewDetailDomain extends Component {
    constructor(props) {
        super();

        this.handleSelectChange = this.handleSelectChange.bind(this);

        this.url = new URL(window.location);
        this.domain = this.url.searchParams.get('domain');
        this.keyword = this.url.searchParams.get('keyword');
        this.intent = this.url.searchParams.get('intent');

        const params = {
            project_id: props.project_id,
            domain: this.domain,
        };

        if (this.intent) {
            params.intent_filter = this.intent?.split(',');
        }

        this.query = query(params);
    }

    searchFunction(data, search) {
        if (!search) return data;
        return data.filter((item) => item?.url?.toLowerCase()?.includes(search.toLowerCase()));
    }

    componentDidUpdate(_, prevState) {
        if (this.state.data && JSON.stringify(this.state.data) !== JSON.stringify(prevState.data)) {
            const data = this.state.data?.map((x) => ({ id: uuid(), ...x }));
            this.setState({ allData: data });
        }
    }

    async handleSelectChange(values) {
        this.setState({
            select: values,
            loading: true,
            data: null,
            allData: [],
        });

        changeIntent(values);

        this.query = query({
            project_id: this.props.project_id,
            intent_filter: values?.map((item) => item.value),
            domain: this.domain,
        });

        this.query.bind(this.setState.bind(this));
        this.query.update();
    }

    render() {
        const { t } = this.props;
        const extraBtns = () => (
            <ExtraBox select={this.state.select} handleSelectChange={this.handleSelectChange} />
        );
        return (
            <>
                <CommerceTabs project_id={this.props.project_id} keyword={this.keyword} />
                <div className="card rounded-main table-main">
                    <div>
                        <CheckData data={this.state?.allData ?? []} loading={this.state.loading}>
                            <DataTable
                                nodes={this.state?.allData ?? []}
                                sortFns={getSortKeys(COLUMNS(t))}
                                header={t('commerce.domain_detail.header')}
                                COLUMNS={COLUMNS(t)}
                                additionalBox={extraBtns}
                                fileName={t('commerce.domain_detail.header')}
                                searchFunction={this.searchFunction}
                                defaultSortKey={'position'}
                                additionalStyles={setAdditionalStyles(COLUMNS(t))}
                                customEmptyMessage="No Data available"
                            />
                        </CheckData>
                    </div>
                </div>
            </>
        );
    }
}

export default withTranslation()(CommerceViewDetailDomain);
